import { ISelect } from '../IComponents.js';

/**
 * BasicSelect - HTML select dropdown
 */
export class BasicSelect extends ISelect {
    constructor(container, options) {
        super(container, options);
        this.value = options.value ?? (options.options?.[0]?.value || '');
        this._create();
    }

    _create() {
        const { options = [], value, label, className, inline } = this.options;

        // For inline selects (like note selectors), don't wrap in a div
        if (inline || className === 'note-select') {
            this.select = document.createElement('select');
            this.select.className = className || '';
            this.element = this.select;

            options.forEach(opt => {
                const option = document.createElement('option');
                option.value = opt.value;
                option.textContent = opt.label;
                if (opt.value === value) {
                    option.selected = true;
                }
                this.select.appendChild(option);
            });

            this.select.addEventListener('change', (e) => {
                this.value = e.target.value;
                this._emitChange(this.value);
            });

            this.container.appendChild(this.select);
            return;
        }

        // Standard select with wrapper
        this.element = document.createElement('div');
        this.element.className = 'select-group';

        this.select = document.createElement('select');
        if (className) this.select.className = className;

        options.forEach(opt => {
            const option = document.createElement('option');
            option.value = opt.value;
            option.textContent = opt.label;
            if (opt.value === value) {
                option.selected = true;
            }
            this.select.appendChild(option);
        });

        // Label
        if (label) {
            this.labelEl = document.createElement('span');
            this.labelEl.className = 'select-label';
            this.labelEl.textContent = label;
        }

        // Event listener
        this.select.addEventListener('change', (e) => {
            this.value = e.target.value;
            this._emitChange(this.value);
        });

        // Assemble
        if (this.labelEl) this.element.appendChild(this.labelEl);
        this.element.appendChild(this.select);

        this.container.appendChild(this.element);
    }

    getValue() {
        return this.value;
    }

    setValue(value) {
        this.value = value;
        this.select.value = value;
    }
}
